/** 用户设置数据 */

import Vue from 'vue'
import * as types from 'store/mutation-types'
import { hasOwnProperty } from 'utils/common'
import getSystemLanguage from 'utils/getSystemLanguage'

export const defaultSettings = Object.freeze({
  visible: false,
  stockColor: 'green-up', // 红涨绿跌
  blinkActive: true, // 闪烁动画
  stockFullscreen: false, // 股票全屏
  theme: 'theme-light', // 主题
  language: getSystemLanguage(), // 语言
  views: {
    'trade-tick-view-open': false,
    'holdings-asset-detail': false,
    'holdings-us-view-open': true,
    'holdings-hk-view-open': true,
    'holdings-uk-view-open': true,
    'holdings-gbp-view-open': true,
    'holdings-usd-view-open': true,
    'holdings-eur-view-open': true,
    'holdings-cn-view-open': true,
    'orders-open-view-open': true,
    'orders-canceled-view-open': true,
    'orders-deal-view-open': true,
    'bookmark-group-view-open': false,
    quotation: [
      'latest-price',
      'hourTrading-pre',
      'hourTrading-after',
      'change-rate',
      'ask-price',
      'bid-price',
      'volume',
      'circulated-value',
      'turnover',
      'short',
      'open',
      'pro-close',
      'high-price',
      'low-price',
      'amount',
      'float-shares',
      'week52-high',
      'week52-low',
      'eps'
    ],
    // Stocklist header sorts
    watchlist: ['default', 'desc'],
    historyList: ['default', 'desc'],
    watchlistTop: ['default', 'desc'],
    volumeTop: ['default', 'desc'],
    amountTop: ['default', 'desc'],
    changeRate5MinTop: ['default', 'desc'],
    changeRate5MinDrop: ['default', 'desc'],
    amplitudeTop: ['default', 'desc'],
    turnoverTop: ['default', 'desc'],
    holdingsUS: ['default', 'desc'],
    holdingsHK: ['default', 'desc'],
    holdingsCN: ['default', 'desc'],
    holdingsUK: ['default', 'desc'],
    holdingsGBP: ['default', 'desc'],
    holdingsEUR: ['default', 'desc'],
    holdingsUSD: ['default', 'desc'],
    holdingsInTrade: ['default', 'desc']
  }
})

const state = Object.assign({}, defaultSettings)

const getters = {
  settingVisible: state => state.visible,
  viewSettings: state => state.views,
  // 服务端需要语言标识
  languageServerNeed(state) {
    return { 'zh-cn': 'zh_CN', 'en-us': 'en_US' }[state.language] || 'en_US'
  },
  // 社区咨询内容语言
  languageNewsContent(state) {
    return { 'zh-cn': 'cn', 'en-us': 'en' }[state.language] || 'en'
  },
  // 图表库标准语言标识
  languageChartNeed(state) {
    return { 'zh-cn': 'zh_cn', 'en-us': 'zh_en' }[state.language] || 'zh_cn'
  },
  language(state) {
    return state.language
  },
  theme(state) {
    return state.theme
  },
  isRedUp(state) {
    return state.stockColor === 'red-up'
  },
  stockFullscreen(state) {
    return state.stockFullscreen
  }
}

const mutations = {
  [types.UPDATE_USER_VIEWS](state, payload) {
    state.views[payload.view] = payload.value
  },
  [types.UPDATE_USER_SETTING](state, setting) {
    for (const key in setting) {
      if (hasOwnProperty(defaultSettings, key)) {
        Vue.set(state, key, setting[key])
      }
    }
  },
  [types.CLEAR_USER_SETTINGS](state) {
    state = defaultSettings
  }
}

const actions = {
  updateViewSettings({ commit }, payload) {
    commit(types.UPDATE_USER_VIEWS, payload)
  },
  updateSettings({ commit }, setting) {
    commit(types.UPDATE_USER_SETTING, setting)
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}
